export default __webpack_public_path__ + "static/media/Quads_1.da0d2593.jpg";